export const SortOrder = {
    asc: 'asc',
    desc: 'desc'
}

export type Sort = {
    order: SortOrder.asc | SortOrder.desc,
    field: string
};
